var map = {
	"./one": [
		35145,
		48802
	],
	"./one.js": [
		35145,
		48802
	],
	"./two": [
		36315,
		17938
	],
	"./two.js": [
		36315,
		17938
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9859;
module.exports = webpackAsyncContext;